import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    constructor(private http: HttpClient) {}

    public get<T>(path, params?): Observable<T> {
        return this.http.get<T>(`${environment.backend.apiHost}/pd/v1${path}`, { params });
    }

    public post<T>(path, body, params?) {
        return this.http.post<T>(`${environment.backend.apiHost}/pd/v1${path}`, body, { params });
    }

    put<T>(path, body, params) {
        return this.http.put<T>(`${environment.backend.apiHost}/pd/v1${path}`, body, { params });
    }
}
